import angular from 'angular';

(function() {
  'use strict';

  // Component DEF
  var kissCreateButton = {
    templateUrl: require('./create-button.html'),
    bindings: {
      isFirst: '=',
      isLast: '=',
      isDisabled: '<',
      actionPrev: '&',
      actionNext: '&'
    }
  };

  // Add to the App
  angular
    .module('app.principal')
    .component('kissCreateButton', kissCreateButton);
})();
